import { Controller } from "@hotwired/stimulus"

// Shows the type specific fields (ship / aircraft) of the event form
// depending on the currently selected event type.
export default class extends Controller {
  static targets = ["select", "ship", "aircraft"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.selectTarget.value

    this.shipTargets.forEach((el) => el.classList.toggle("hidden", type !== "ship"))
    this.aircraftTargets.forEach((el) => el.classList.toggle("hidden", type !== "aircraft"))
  }
}
